<template>
  <div class="mx-auto max-w-5xl flex flex-col gap-4 lg:gap-6">
    <div class="flex flex-col gap-1">
      <h2 class="text-2xl font-bold tracking-tight">
        {{ t('dashboard.greeting', { name: accountRef?.firstName }) }}
        <!-- Emoji hors de la chaine traduite pour pouvoir l'animer seul. -->
        <span class="dashboard-greeting-hand" aria-hidden="true">👋</span>
      </h2>
      <p class="text-muted-foreground">{{ t('dashboard.subtitle') }}</p>
    </div>
    <DashboardProgramProgress />
  </div>
</template>

<script setup lang="ts">
import useAccount from '@/features/auth/hooks/use-account.hook'
import DashboardProgramProgress from '@/features/ui/pages/dashboard/dashboard-content/shared/dashboard-program-progress/dashboard-program-progress.vue'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const { accountRef } = useAccount()
</script>

<style lang="scss" scoped>
.dashboard-greeting-hand {
  display: inline-block;
  // Police emoji du systeme : Apple Color Emoji sur Mac et iPhone, a defaut celle de l'OS.
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif;
  transform-origin: 70% 80%;
  animation: dashboard-greeting-wave 3.6s cubic-bezier(0.34, 1.56, 0.64, 1) 1 both;
}

@keyframes dashboard-greeting-wave {
  0%,
  60%,
  100% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(16deg);
  }
  30% {
    transform: rotate(-8deg);
  }
  45% {
    transform: rotate(12deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .dashboard-greeting-hand {
    animation: none;
  }
}
</style>
